import { Component } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  query,
} from '@angular/animations'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  

})
export class AppComponent {
  title = 'app';
  getRouteAnimation(outlet) {
      
      return outlet.activatedRouteData.animation
  }
}



// WEBPACK FOOTER //
// E:/sree/New folder (3)/cdk-material-v2/src/app/app.component.ts